import { secondaryFontFamily, styled } from '@openeducation/oe-rn-themes';
import React from 'react';
import { Platform } from 'react-native';

import { StepCircle } from './step-circle';
import { OEText } from '../../atoms';

interface StepperStepsProps {
  steps: string[];
  currentStep: number;
  horizontal?: boolean;
  size: number;
}

export function StepperSteps({
  steps,
  currentStep,
  horizontal,
  size,
}: StepperStepsProps) {
  return (
    <>
      {steps.map((stepTitle, i) => {
        const stepNumber = i + 1;
        const active = currentStep === stepNumber;
        const completed = currentStep > stepNumber;
        return (
          <StepContainer
            key={i}
            stepNumber={stepNumber}
            horizontal={horizontal}
            size={size}
          >
            <StepCircle
              stepNumber={stepNumber}
              active={active}
              completed={completed}
              horizontal={horizontal}
            />
            {!horizontal && (
              <TitleContainer>
                <Title active={active} completed={completed}>
                  {stepTitle}
                </Title>
              </TitleContainer>
            )}
          </StepContainer>
        );
      })}
    </>
  );
}

interface StepContainerProps {
  stepNumber: number;
  horizontal?: boolean;
  size: number;
}

interface TitleProps {
  completed?: boolean;
  active?: boolean;
}

const containerMargin = ({
  stepNumber,
  horizontal,
  size,
}: StepContainerProps) =>
  (size / 2) * (stepNumber + (stepNumber - (horizontal ? 2 : 1)));
const StepContainer = styled.View<StepContainerProps>`
  position: absolute;

  ${({ horizontal, stepNumber, size }) =>
    `${horizontal ? 'left' : 'top'}: ${containerMargin({
      horizontal,
      stepNumber,
      size,
    })}px`};

  align-items: center;
  justify-content: center;
  flex-direction: row;
`;

const TitleContainer = styled.View`
  width: ${Platform.select({ web: 'max-content', default: 'auto' })};
  position: absolute;
  left: 44px;
`;

const Title = styled(OEText).attrs({
  fontFamily: secondaryFontFamily,
})<TitleProps>`
  font-size: ${({ active }) => (active ? 20 : 18)}px;
  color: ${({ theme: { color }, completed, active }) => {
    const colors = {
      [color.accent]: completed,
      [color.dark1]: active,
    };

    return Object.keys(colors).find((key: any) => !!colors[key]) || color.dark3;
  }};
  font-weight: ${({ active, completed }) => (active || completed ? 700 : 400)};
`;
